export default "__VITE_ASSET__DpIt0k09__"